/**
 * 完売商品表示フィルター
 * 2026年2月19日 修正版28（デスクトップ・モバイル対応・歯抜け解消対応）
 * お客様がチェックを入れたときに、完売商品を非表示にする
 */

function toggleSoldOutProducts() {
  // デスクトップ版のチェックボックス
  const checkboxDesktop = document.getElementById('hide-sold-out');
  // モバイル版のチェックボックス
  const checkboxMobile = document.getElementById('hide-sold-out-mobile');

  // どちらかのチェックボックスがオンか確認
  const hideSoldOut = (checkboxDesktop && checkboxDesktop.checked) || 
                      (checkboxMobile && checkboxMobile.checked);

  const productCards = document.querySelectorAll('product-card[data-available]');

  productCards.forEach(function (card) {
    const isAvailable = card.getAttribute('data-available');
    const colWrapper = card.closest('.col'); // 歯抜け防止のため .col を対象に

    if (hideSoldOut && isAvailable === 'false') {
      if (colWrapper) {
        colWrapper.classList.add('sold-out-hidden');
      }
    } else {
      if (colWrapper) {
        colWrapper.classList.remove('sold-out-hidden');
      }
    }
  });
}

function syncCheckboxes(sourceCheckbox, targetCheckbox) {
  if (sourceCheckbox && targetCheckbox) {
    targetCheckbox.checked = sourceCheckbox.checked;
  }
}

function initSoldOutFilter() {
  const checkboxDesktop = document.getElementById('hide-sold-out');
  const checkboxMobile = document.getElementById('hide-sold-out-mobile');

  // 初期状態：両方のチェックボックスをオフ
  if (checkboxDesktop) {
    checkboxDesktop.checked = false;
  }
  if (checkboxMobile) {
    checkboxMobile.checked = false;
  }

  toggleSoldOutProducts();

  // デスクトップ版のチェックボックスの変更を監視
  if (checkboxDesktop) {
    checkboxDesktop.addEventListener('change', function() {
      syncCheckboxes(checkboxDesktop, checkboxMobile);
      toggleSoldOutProducts();
    });
  }

  // モバイル版のチェックボックスの変更を監視
  if (checkboxMobile) {
    checkboxMobile.addEventListener('change', function() {
      syncCheckboxes(checkboxMobile, checkboxDesktop);
      toggleSoldOutProducts();
    });
  }

  // DOMの変化を監視して、商品カードが追加されたら再チェック
  const observer = new MutationObserver(() => {
    toggleSoldOutProducts();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if ('customElements' in window) {
  customElements.whenDefined('product-card').then(() => {
    window.addEventListener('load', function () {
      setTimeout(initSoldOutFilter, 300);
    });
  });
} else {
  window.addEventListener('load', function () {
    setTimeout(initSoldOutFilter, 300);
  });
}










